import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { defaultTo, path } from 'ramda';
import moment from 'moment';

import { apiGetExtenson, apiApproveExtension, apiRejectExtension } from '../../../../api/extension';
import { routes } from '../../../../routes';
import { handleErrorBase, handleSuccessBase } from '../../../../util/forms';

import Card from '../../../../components/Card';
import FlaggedUserModal from '../../../../components/Modal/FlaggedUserModal';

class Review extends Component {
  static propTypes = {
    history: PropTypes.object,
  };

  state = {
    extension: null,
    loaded: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedExtensionId = match.params.id;

    apiGetExtenson(selectedExtensionId).then((resp) => this.setState({ extension: resp.data, loaded: true }));
  }

  renderReviewsTable = () => {
    const { extension } = this.state;
    const reviews = defaultTo([], extension.reviews);

    if (reviews.length == 0) {
      return (
        <p>
          <strong>Status: </strong>
          {extension.approved ? 'Approved' : 'Rejected'}
        </p>
      );
    }

    return (
      <Fragment>
        <h4 className="bold-blue-heading mt-5 mb-3">Extension Review</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Reviewer</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review) => (
              <tr key={review.id}>
                <td>{moment(review.createdAt).format('MM/DD/YYYY')}</td>
                <td>
                  {path(['user', 'firstName'], review)} {path(['user', 'lastName'], review)}
                </td>
                <td>{extension.approved ? 'Approved' : 'Rejected'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Fragment>
    );
  };

  renderReviewButtons = () => {
    const { extension } = this.state;
    const { history } = this.props;

    return (
      <div className="form-group text-right mb-0">
        <button
          type="button"
          className="btn btn-danger mr-2"
          onClick={() =>
            apiRejectExtension(extension.id)
              .then(() => history.push(routes.admin.extensions.root))
              .then(handleSuccessBase)
              .catch((err) => handleErrorBase('Could not reject extension'))
          }
        >
          Reject
        </button>
        <button
          type="button"
          className="btn btn-primary mr-2"
          onClick={() =>
            apiApproveExtension(extension.id)
              .then(() => history.push(routes.admin.extensions.root))
              .then(handleSuccessBase)
              .catch((err) => handleErrorBase('Could not approve extension'))
          }
        >
          Approve
        </button>
      </div>
    );
  };

  render() {
    if (!this.state.loaded) return <noscript />;
    const { extension } = this.state;
    const isRegistration = extension.category.step;
    const name = isRegistration
      ? path(['category', extension.category.trainingId ? 'training' : 'certification', 'name'], extension)
      : path(['category', 'name'], extension);

    return (
      <div className="row">
        <div className="col">
          {extension && (
            <FlaggedUserModal
              user={extension.user}
            >
            </FlaggedUserModal>
          )}
          <Card>
            <Card.Header compact>Extension Approval</Card.Header>
            <Card.Body>
              <p>
                <strong>User: </strong>
                <Link to={routes.admin.users.profileBuilder(path(['user', 'id'], extension))}>
                  {path(['user', 'firstName'], extension)} {path(['user', 'lastName'], extension)}
                </Link>
              </p>
              <p>
                <strong>Submitted: </strong>
                {moment(extension.createdAt).format('MM/DD/YYYY')}
              </p>
              <p>
                <strong>Type: </strong>
                {isRegistration ? 'Registration Extension' : 'Certification Extension'}
              </p>
              <p>
                <strong>Program: </strong>
                {name}
              </p>
              <p>
                <strong>Completed Hours: </strong>
                {extension.completedHours}
              </p>
              <p>
                <strong>Essay: </strong>
                {extension.essay}
              </p>
              {extension.approved != null ? this.renderReviewsTable() : this.renderReviewButtons()}
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default withRouter(Review);
